import { jarvisOnestockDashboardConstants } from "./jarvisOnestockDashboardConstants";

const jarvisOnestockDashboardAction = {};

jarvisOnestockDashboardAction.getDashboardStats = () => ({
    type: jarvisOnestockDashboardConstants.JARVIS_ONESTOCK_DASHBOARD_STATS_SAGA,
});

jarvisOnestockDashboardAction.getDashboardReveal = () => ({
    type: jarvisOnestockDashboardConstants.JARVIS_ONESTOCK_DASHBOARD_REVEAL_SAGA,
});
jarvisOnestockDashboardAction.getDashboardStatsV2 = () => ({
    type: jarvisOnestockDashboardConstants.JARVIS_ONESTOCK_DASHBOARD_STATSV2_SAGA,
})

export { jarvisOnestockDashboardAction };
